module.exports = "import React from 'react';\nimport DayPicker from 'react-day-picker';\nimport 'react-day-picker/lib/style.css';\n\nexport default function Example() {\n  return (\n    <DayPicker\n      initialMonth={new Date(2017, 3)}\n      selectedDays={[\n        new Date(2017, 3, 12),\n        new Date(2017, 3, 2),\n        {\n          after: new Date(2017, 3, 20),\n          before: new Date(2017, 3, 25),\n        },\n      ]}\n    />\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/examples/selected.js
// module id = 795
// module chunks = 168707334958949